import React from 'react';
import { useWizard } from '../../wizard/WizardContext';
import { ProviderSelect } from '../ProviderSelect';
import { Option } from 'src/components/SelectBox';
import { AutoCompleteInput } from 'src/components/AutoCompleteInput';
import useAuthedRequest from 'src/hooks/useAuthedRequest';

export interface EmailProviderSelectionProps {
  onChange: (providerOption: { value: string; label: string }) => void;
  isAuthenticated?: boolean;
}

export const EmailProviderSelect: React.FC<EmailProviderSelectionProps> = ({
  onChange,
  isAuthenticated = false,
}) => {
  const { emailProviders, campaignAutomation, setCampaignAutomation } =
    useWizard();
  const { get, remove } = useAuthedRequest();

  const handleChange = (option: Option) => {
    onChange({
      value: option.value,
      label: option.label || option.value,
    });
  };

  const fetchLastEmails = async (search: string) => {
    try {
      const data = await get(`/emails/recent?email=${search}`);
      return data.map((i: { id: string; email: string }) => ({
        id: i.id,
        label: i.email,
        value: i.email,
      }));
    } catch (error) {
      console.error('Failed to fetch last emails:', error);
      return [];
    }
  };

  const handleFromEmailChange = (value: string) => {
    setCampaignAutomation({
      ...campaignAutomation,
      fromEmail: value,
    });
  };

  return (
    <>
      <ProviderSelect
        providers={emailProviders}
        selectedProvider={campaignAutomation.emailProviderOption}
        onChange={handleChange}
        isAuthenticated={isAuthenticated}
        label="Email Provider"
        htmlFor="email-provider"
        className="w-full bg-neutral-0"
      />

      {isAuthenticated && (
        <div className="w-full sm:w-80 flex-shrink-0">
          <AutoCompleteInput
            label="From Email"
            id="email-from"
            placeholder="Enter sender email"
            value={campaignAutomation.fromEmail || ''}
            onChange={handleFromEmailChange}
            onRemove={(value) => remove(`/emails/recent/${value}`)}
            required
            fetchOptions={fetchLastEmails}
          />
        </div>
      )}
    </>
  );
};
